export const map = {
    'src': 'data-src',
    'srcSet': 'data-srcset'
};